import Api from '@/api'

const state = {
    upcoming: [],
}

const getters = {
    upcoming: state => state.upcoming,
}

const mutations = {
    setUpcoming(state, upcoming) {
        state.upcoming = upcoming
    },
}

const actions = {
    updateUpcoming: ({ commit }, upcoming) => commit('setUpcoming', upcoming),

    fetch ({commit}) {
        // axios request
        return Api.request('get', 'api/birthdays/upcoming').then(({data}) => {
            commit('setUpcoming', data.birthdays)
        });
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
